import React, {Component} from 'react';
import {AdsManagerContainer} from "../../../../Ads/components/AdsManagerContainer";

class Descripcion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hideEmail: props.hideEmail ?? true
        }

        this.parseTextToHTML = this.parseTextToHTML.bind(this);
        this.parseLineToHtml = this.parseLineToHtml.bind(this);
        this.clickLinkDescripcion = this.clickLinkDescripcion.bind(this);
        this.clickLinkTeamingDescripcion = this.clickLinkTeamingDescripcion.bind(this);
        this.clickEmailDescripcion = this.clickEmailDescripcion.bind(this);
        this.insertAds = this.insertAds.bind(this);
    }

    clickLinkDescripcion() {
        this.props.onClickLink()
    }

    clickLinkTeamingDescripcion() {
        this.props.onClickLinkTeaming()
    }

    clickEmailDescripcion() {
        this.props.onClickEmail()
    }

    parseURL(url, index) {
        return <a id={"link_descripcion_" + index} className="linkDescription" onClick={this.clickLinkDescripcion}
                  href={url} target="_blank" key={"" + Math.random() + ""} rel="nofollow"> {url}</a>
    }

    parseURLTeaming(url, index) {
        return <a id={"link_descripcion_teaming_" + index} className="linkDescription"
                  onClick={this.clickLinkTeamingDescripcion}
                  href={url} target="_blank" key={"" + Math.random() + ""} rel="nofollow"> {url}</a>
    }

    parseEmail(email, index) {
        if (this.state.hideEmail) {
            return <a id={"email_descripcion_" + index} className="linkDescription" onClick={this.clickEmailDescripcion}
                      key={"" + Math.random() + ""} rel="nofollow"> contactar por
                email{(this.props.nombre) ? " con " + this.props.nombre : ""} </a>
        } else {
            return <a id={"email_descripcion_" + index} className="linkDescription" onClick={this.clickEmailDescripcion}
                      key={"" + Math.random() + ""} rel="nofollow" href={"mailto:" + email}> {email}</a>
        }
    }

    parseLineToHtml(line, index) {
        if (line == null) return line

        const regex_url = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/img
        const regex_email = /(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/img;
        const regex_telefono = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/img

        const urls_match = line.match(regex_url) || []
        const emails_match = line.match(regex_email) || []

        const myLine = line.split(" ")?.flatMap((word) => {

            if (urls_match.includes(word)) {
                if (word.includes("teaming")) return this.parseURLTeaming(word, urls_match.findIndex(w => w === word))
                return this.parseURL(word, urls_match.findIndex(w => w === word))
            }
            if (emails_match.includes(word)) {
                return this.parseEmail(word, emails_match.findIndex(w => w === word))
            }
            return " " + word + " "
        })

        return <p key={index} style={this.props.pStyle || {}}>{myLine || ""}</p>
    }

    parseTextToHTML(text) {
        if (text == null) return text;

        const that = this;
        return text.split("\n").map((line, index) => {
            if (line && line.trim() !== '') return that.parseLineToHtml(line, index);
        }).filter(l => l !== undefined)
    }

    insertAds(arrayLinesHTML) {
        if (Array.isArray(arrayLinesHTML) && this.props.adsConfig) {
            const maxAds = this.props.adsConfig.adsTypes.length
            let paragraphsBetweenAds = Math.floor(arrayLinesHTML.length / maxAds)
            let counterP = paragraphsBetweenAds
            let adsInserted = 0
            for (let i = 0; i < arrayLinesHTML.length && adsInserted < maxAds; i++) {
                if (counterP === 0/* || startPosition === i*/) {
                    // console.log("INSERTANDO AD TYPE -> " + this.props.adsConfig.adsTypes[adsInserted] + " | pos = " + i)
                    arrayLinesHTML.splice(i, 0, <AdsManagerContainer
                        type={this.props.adsConfig.adsTypes[adsInserted]} key={Math.random()}/>)
                    counterP = paragraphsBetweenAds
                    i++
                    adsInserted++
                }
                --counterP
            }
            if (this.props.adsConfig.insertAtEnd && adsInserted < maxAds) {
                // console.log("INSERTANDO AD TYPE -> " + this.props.adsConfig.adsTypes[adsInserted] + " | pos = last")
                arrayLinesHTML.push(<AdsManagerContainer type={this.props.adsConfig.adsTypes[adsInserted]} key={Math.random()}/>)
            }
        }
        return arrayLinesHTML
    }

    render() {
        const notTitle = this.props.notTitle
        const title = (this.props.title) ? this.props.title : "Información"
        let descripcion = this.parseTextToHTML(this.props.descripcion||"")
        descripcion = this.insertAds(descripcion);

        return (
            <div className="informationDetailDescriptionButtom">
                {!notTitle && title && <h2 className="card-title ">{title}</h2>}
                <div className="descripcion">
                    {descripcion}
                </div>

            </div>
        )
    }

}


export default Descripcion